import { Box, Flex, Step, StepIndicator, StepSeparator, StepStatus, StepTitle, Stepper, Text } from '@chakra-ui/react';

import React from 'react';
import { RootState } from 'src/store/store';
import { Stepper_labels_English } from 'src/common/constants/englishLabels';
import { Stepper_labels_Hindi } from 'src/common/constants/hindiLabels';
import TickIcon from 'src/resources/icons/TickIcon';
import { useSelector } from "react-redux";

type StepperComponentProps = {
  currentStep: number
}
const StepperComponent: React.FC<StepperComponentProps> = (props: StepperComponentProps) => {
  const { currentStep } = props
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const stepsEnglish = Object.values(Stepper_labels_English);
  const stepsHindi = Object.values(Stepper_labels_Hindi)
  const steps = isHindiLabels ? stepsHindi : stepsEnglish

  return (
    <Box width="100%">
      <Stepper index={currentStep}>
        {steps.map((step, index) => (
          <Step key={index}>
            <Flex alignItems="center" w="100%" justifyContent="space-between">
              <StepIndicator style={{ border: "none", background: "white", backgroundColor: "white" }}>
                <StepStatus
                  complete={<TickIcon isTicked={true} />}
                  active={<TickIcon />}
                  incomplete={<TickIcon isIncomplete={true} />}
                />
              </StepIndicator>
              <>
                  <Box display={["none", "none", "none", "flex"]} flexShrink='0'>
                    <StepTitle style={{ color: currentStep < index ? "#D5DBE3" : "black" }}>{step}</StepTitle>
                  </Box>
                <StepSeparator style={{ backgroundColor: currentStep < index ? "#D5DBE3" : "#FF7E6B" }} />
              </>
            </Flex>
          </Step>
        ))}
      </Stepper>
        <Flex display={["flex", "flex", "flex", "none"]} justifyContent="center">
          <Text fontWeight={700} color="black">{steps[currentStep]}</Text>
        </Flex>
    </Box>
  );
};

export default StepperComponent;
